module.exports = __webpack_public_path__ + "static/media/1.e9b794e9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/1.mp3
// module id = 80
// module chunks = 0